import { isSet } from '../utils/isSet';
import { Dropdown } from './Dropdown';

class PhoneSelector {
    constructor(root){
        this.root = root;

        this.init();
    }

    init(){
        console.log(this.root);
        this.init__dropdown();
    }

    init__dropdown(){
        if(this.dropdownAPI) return;

        this.dropdownAPI = new Dropdown(
            this.root,
            {
                closeOnItemClick: true,
                updateOnItemClick: false,
                onAfterOpen: (obj, e) => {

                },
                onAfterClose: (obj, e) => {

                },
                onSelection: (obj, tgt, e) => {
                    obj.trigger.querySelector('img').remove();

                    const flagSVG = tgt.querySelector('img').cloneNode(true);
                    obj.trigger.prepend(flagSVG);

                    const currentNumber = obj.root.querySelector('.phone-selector__current');
                    currentNumber.innerHTML = '<span>' + tgt.getAttribute('data-label') + '</span>';
                    currentNumber.href = 'tel:' + tgt.getAttribute('data-value');
                }
            }
        )
    }

}

export { PhoneSelector }